import React from 'react';
import { Box } from '@mui/material';
import CincopaDefaultGallery from '@/components/gallery/CincopaDefaultGallery';
import useAppSelector from '@/hooks/useAppSelector';
import {
  getMyCompanyDetails,
  getUserSelector,
} from '@/redux/selectors/userSelectors';

const Moments: React.FC = () => {
  const user = useAppSelector(getUserSelector);
  const myCompanyDetails = useAppSelector(getMyCompanyDetails);
  const company = myCompanyDetails || user?.companies?.[0];

  return (
    <Box padding="20px">
      <CincopaDefaultGallery fid={ company?.cincopaFid } />
    </Box>
  );
};

export default Moments;

